import * as React from "react"
import { Link } from "gatsby"

export function Navlink({ href, activeClassName, className, children }) {
  const url = href.indexOf("http") === 0 ? href : `/${href}`

  return (
    <Link
      to={url}
      className={className}
      activeClassName={activeClassName}
      rel={url === "/" ? "canonical" : ""}
    >
      {children}
    </Link>
  )
}

export default Navlink
